import * as prismic from "@prismicio/client";

const endpoint = prismic.getRepositoryEndpoint("pennsylvania-squeeze");
const accessToken =
  "MC5hSkpESVJJQUFDQUF4eTZ0.77-9I--_vWfvv71j77-9KWDvv70xFgTvv73vv73vv71XMe-_ve-_vWxn77-977-977-977-977-977-977-9Hu-_ve-_vQ"; // Set an access token
const routes = [];

const client = prismic.createClient(endpoint, { routes, accessToken });

export default client;
